import React, { useEffect, useState } from "react";
import { Container, Col, FormGroup, Label, Row, Button, Input, Modal, ModalHeader, ModalBody, Table } from "reactstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loading } from "../share/loading";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import '../share/TabStyle.css'
import "../share/form.css";
import "./Admin.css";
import "../borrowSystem/BorrowForm/TabBorrowComponent.css";
import { FaSistrix } from "react-icons/fa";
import { NumberWithCommmas2 } from "../share/NumberWithCommmas2";
import CreateTableComponent from "../share/CreateTableComponent";
import { BsDownload } from "react-icons/bs";
import { useFormik } from 'formik';

export function AdminDetailComponent() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    // const [trainJobposition, setTrainJobposition] = useState([]);
    const [testJobposition, setTestJobposition] = useState([]);
    const [trainData, setTrainData] = useState([]);
    const [testData, setTestData] = useState([]);
    const [tabIndex, setTabIndex] = useState(0);
    const [tabSubIndex, setTabSubIndex] = useState(0);
    const [openModalForm, setOpenModalForm] = useState(false);
    const Toggle = () => setOpenModalForm(!openModalForm);
    const styled = {
        backgroundColor: "rgba(250, 237, 161, 0.3)",
        border: "1px solid rgba(250, 200, 100)"
    }

    const classNameToShow = "input-color text-center rounded-pill";

    useEffect(() => {
        getCheckBorrow();
        getAllTrainData();
        getAllTestData();
        getTrainJobposition();
        ListTrainTestJobposition();
        // getJobTrainPosition();
    }, []);

    // ดึงข้อมูลจาก td borrow
    async function getCheckBorrow() {
        setLoading(true);
        let postData = new FormData();
        // postData.append("deptId", user.deptId)
        postData.append("borrowId", searchParams.get("id"));
        try {
            let res = await fetch("/api/BorrowRegis/considerBorrowing", {
                method: "POST",
                body: postData,
            });
            const data = await res.json();
            // console.log(data.dataenum);
            setData(data.dataenum);
        } catch (e) {
            console.log("err =>" + e);
        } finally {
            setLoading(false);
        }
    }

    async function getAllTrainData() {
        setLoading(true);
        let postData = new FormData();
        // postData.append("deptId", user.deptId)
        postData.append("borrowId", searchParams.get("id"));
        try {
            let res = await fetch("/api/Borrow/getAllTrainData", {
                method: "POST",
                body: postData,
            });
            const data = await res.json();
            setTrainData(data.dataenum);
            // console.log(data.dataenum);
        } catch (e) {
            console.log("err =>" + e);
        } finally {
            setLoading(false);
        }
    }

    async function getAllTestData() {
        setLoading(true);
        let postData = new FormData();
        // postData.append("deptId", user.deptId)
        postData.append("borrowId", searchParams.get("id"));
        try {
            let res = await fetch("/api/Borrow/getAllTestData", {
                method: "POST",
                body: postData,
            });
            const data = await res.json();
            setTestData(data.dataenum);
            // console.log(data.dataenum);
        } catch (e) {
            console.log("err =>" + e);
        } finally {
            setLoading(false);
        }
    }


    const [detailJobPositionDataAr, setDetailJobPositionDataAr] = useState([]);
    // console.log("detailJobPositionDataAr", detailJobPositionDataAr);
    const [courseSelect, setCourseSelect] = useState([]);
    // console.log("courseSelect", courseSelect);

    async function getTrainJobposition() {
        setLoading(true)
        let postData = new FormData();
        postData.append("borrowId", searchParams.get("id"))
        // postData.append("trainTest",1)
        try {

            let res = await fetch("/api/BorrowRegis/getTrainTestJobposition", {
                method: "POST",
                body: postData
            });
            const resJson = await res.json()
            // console.log("resJsongetTrainJobposition",resJson.dataenum)
            setDetailJobPositionDataAr(resJson.dataenum.filter(item => {
                return item.trainJobpositionName != null
            }));
        } catch (e) {
            console.log(e)
        } finally {
            setLoading(false)
        }
    }

    async function ListTrainTestJobposition() {
        setLoading(true)
        try {
            let res = await fetch("/api/BorrowRegis/listTrainTestJobposition", {
                method: "POST",
                headers: { "Content-type": "application/json" },
                body: JSON.stringify({
                    "BorrowId": searchParams.get("id")
                }),
            });
            const resJson = await res.json()
            // console.log('resJson',resJson.dataenum)
            setCourseSelect(resJson.dataenum.filter(item => {
                return item.trainCourseId != null
            }));
            // console.log(resJson.dataenum);
        } catch (err) {
            console.log("err =>" + err)
        } finally {
            setLoading(false)
        }
    }




    // const COLUMNSTRAIN = [
    //     {
    //         Header: "ลำดับ",
    //         accessor: (_row, i) => i + 1,
    //     },
    //     {
    //         Header: "ชื่อตำแหน่งงาน",
    //         accessor: "jobpositionName",
    //     },
    //     {
    //         Header: "ชื่อหลักสูตร",
    //         accessor: "courseName",
    //     },
    //     {
    //         Header: "รุ่นที่",
    //         accessor: "class",
    //     },
    //     {
    //         Header: "จำนวน (คน)",
    //         accessor: "total",
    //     },

    // ]

    const COLUMNSTEST = [
        {
            Header: "ลำดับ",
            accessor: (_row, i) => i + 1,
        },
        {
            Header: "ชื่อตำแหน่งงาน",
            accessor: "jobpositionName",
        },
        {
            Header: "ชื่อสาขาอาชีพ",
            accessor: "lawOccupationName",
        },
        {
            Header: "รุ่นที่",
            accessor: "time",
        },
        {
            Header: "จำนวน (คน)",
            accessor: "total",
        },

    ]

    const trainJobInititalValues = {
        id: 0,
        trainJobpositionName: "",
        trainCourses: courseSelect.map((course) => ({
            trainCourseId: course.trainCourseId,
            trainClasses: course.listTrainClasses.map((classItem) => ({
                personAmount: "",
                trainClassId: 0
            }))
        }))
    }

    const trainFormik = useFormik({
        enableReinitialize: true,
        initialValues: trainJobInititalValues,
    })

    async function OnWatch(row) {
        trainFormik.resetForm();
        // console.log("row", row)
        trainFormik.setFieldValue("id", row.id)
        trainFormik.setFieldValue("trainJobpositionName", row.trainJobpositionName)
        await courseSelect.forEach((course, i) => {
            row.trainCourses.forEach((mycourse) => {
                if (course.trainCourseId === mycourse.trainCourseId) {
                    course.listTrainClasses.forEach((classItem, index) => {
                        mycourse.trainClasses.forEach((myClass) => {
                            if (classItem.trainClassId === myClass.trainClassId) {
                                trainFormik.setFieldValue(`trainCourses[${i}].trainClasses[${index}].trainClassId`, myClass.trainClassId);
                                trainFormik.setFieldValue(`trainCourses[${i}].trainClasses[${index}].personAmount`, myClass.personAmount);
                            }
                        })
                    })

                }
            })
        })
        await Toggle(!openModalForm);
    }
    console.log("formik.value", trainFormik.values);

    const COLUMNSTRAIN = [
        {
            Header: "ลำดับ",
            accessor: (_row, i) => i + 1,
        },
        {
            Header: "ชื่อตำแหน่งงาน",
            accessor: "trainJobpositionName",
        },
        {
            Header: "จำนวนผู้เข้ารับการฝึกอบรม",
            accessor: "personAmount",
        },
        {
            Header: "รายละเอียด",
            accessor: "id",
            Cell: ({ row, value }) => {
                return (
                    <div className="text-center">
                        <FaSistrix className="mx-2 style-icon" onClick={() => OnWatch(row.original)} />
                    </div>
                );
            },
        },
    ];

    if (loading) { return <Loading /> }

    return (
        <>
            <Container style={{ width: "100%", maxWidth: "1140px" }}>
                <Tabs>
                    <TabList className="d-flex flex-wrap justify-content-center w-100">
                        <Tab>คำขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน</Tab>
                        <Tab>รายละเอียดการขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน</Tab>
                        <Tab>ข้อมูลตำแหน่งงานการขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน</Tab>
                    </TabList>
                    {/* คำขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน */}
                    <TabPanel>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            <div className="form-border p-5">
                                {/* input เลือกหน่วยงาน */}
                                <FormGroup>
                                    <Label for="dept">
                                        ยื่นคำขอที่
                                    </Label>
                                    <Input value={data?.deptName ? data?.deptName : "-"} className={classNameToShow} style={styled} disabled />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="dept">
                                        ชื่อผู้กู้ยืม
                                    </Label>
                                    <Input value={data?.employee ? data?.employee : "-"} className={classNameToShow} style={styled} disabled />
                                </FormGroup>


                                <FormGroup>
                                    <Label for="dept">
                                        เลขทะเบียนนิติบุคคล
                                    </Label>
                                    <Input value={data?.customerNo ? data?.customerNo : "-"} className={classNameToShow} style={styled} disabled />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="dept">
                                        เลขที่ใบอนุญาตการเป็นผู้ดำเนินการฝึก
                                    </Label>
                                    <Input value={data?.licenseNo ? data?.licenseNo : "-"} className={classNameToShow} style={styled} disabled />
                                </FormGroup>

                                <Row>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label for="">
                                                ประเภทผู้กู้ยืม
                                            </Label>
                                            <Input value={data?.borrowType ? data?.borrowType : "-"} className={classNameToShow} style={styled} disabled />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label for="">
                                                ประเภทธุรกิจ
                                            </Label>
                                            <Input value={data?.businessType ? data?.businessType : "-"} className={classNameToShow} style={styled} disabled />
                                        </FormGroup>
                                    </Col>
                                </Row>

                                {/* ผู้กระทำการแทน คำนำหน้าและชื่อ */}
                                <hr />
                                <FormGroup>
                                    <Label for="">
                                        กระทำการโดย
                                    </Label>
                                    <Input value={data?.fullName ? `${data?.titleName + " " + data?.fullName}` : "-"} className={classNameToShow} style={styled} disabled />
                                </FormGroup>
                                <Row>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label for="">
                                                เลขประจำตัวประชาชน
                                            </Label>
                                            <Input value={data?.personalNo ? data?.personalNo : "-"} className={classNameToShow} style={styled} disabled />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label for="">
                                                ตำแหน่ง
                                            </Label>
                                            <Input value={data?.position ? data?.position : "-"} className={classNameToShow} style={styled} disabled />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label for="">
                                                อายุ
                                            </Label>
                                            <Input value={data?.age ? data?.age : "-"} className={classNameToShow} style={styled} disabled />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label for="">
                                                สัญชาติ
                                            </Label>
                                            <Input value={data?.national ? data?.national : "-"} className={classNameToShow} style={styled} disabled />
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label for="">
                                                วันที่บัตรหมดอายุ
                                            </Label>
                                            <Input value={data?.cardExpireDate ? data?.cardExpireDate : "-"} className={classNameToShow} style={styled} disabled />
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label for="">
                                                วัน/เดือน/ปีเกิด
                                            </Label>
                                            <Input value={data?.birthDate ? data?.birthDate : "-"} className={classNameToShow} style={styled} disabled />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <hr />

                                {/* input จำนวนลูกจ้าง */}
                                <FormGroup>
                                    <Label for="">
                                        จำนวนลูกจ้างที่นำส่งเงินสมทบประกันสังคม ( ณ เดือนที่ยื่นคำขอกู้)
                                    </Label>
                                    <Input value={data?.employeeAmount ? `${NumberWithCommmas2(data?.employeeAmount) + " " + "คน"}` : "-"} className={classNameToShow} style={styled} disabled />
                                </FormGroup>

                                <div className="mt-4 border border-1 mb-4">
                                    {/* <Label className="">หลักประกันในการกู้ยืม</Label> */}
                                    <p className="text-center text-white" style={{ lineHeight: "3rem", backgroundColor: "#0A66C2" }}>หลักประกันในการกู้ยืม</p>
                                    <FormGroup className="mx-5 mt-3">
                                        <Label>บุคคลค้ำประกัน</Label>
                                        <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                            {data.titleGuarantee}{" "}
                                            {data.guaranteeName
                                                ? data.guaranteeName
                                                : "-"}
                                        </p>
                                        <Label>ตำแหน่งงาน</Label>
                                        <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                            {data.guaranteePosition
                                                ? data.guaranteePosition
                                                : "-"}
                                        </p>
                                    </FormGroup>
                                    <div className="d-flex flex-column">
                                        {data?.fBondPath != null ? (
                                            <FormGroup className='d-flex justify-content-between flex-wrap align-items-center'>
                                                <span className="px-3">พันธบัตรรัฐบาลไทย</span>
                                                <Button
                                                    href={data?.fBondPath}
                                                    className="download-btn me-3 rounded-pill"
                                                    download
                                                >
                                                    <BsDownload className="me-2" />
                                                    ดาวน์โหลด
                                                </Button>
                                            </FormGroup>
                                        ) : null}
                                        {data?.fBankGuaranteePath != null ? (
                                            <FormGroup className='d-flex justify-content-between flex-wrap align-items-center'>
                                                <span className="px-3">หนังสือค้ำประกันธนาคาร</span>
                                                {/* <span className="px-3">เอกสารเครดิตบูโร</span> */}
                                                <Button
                                                    href={data?.fBankGuaranteePath}
                                                    className="download-btn mx-3 rounded-pill"
                                                    download
                                                >
                                                    <BsDownload className="me-2" />
                                                    ดาวน์โหลด
                                                </Button>
                                            </FormGroup>
                                        ) : null}
                                    </div>

                                </div>

                                <div className="border border-1">
                                    <p className="text-center text-white" style={{ lineHeight: "3rem", backgroundColor: "#0A66C2" }}>เอกสารประกอบการยื่น</p>
                                    <div className="d-flex flex-column">
                                        {data?.fAuthorisePath != null ? (
                                            <FormGroup className='d-flex justify-content-between flex-wrap align-items-center'>
                                                <span className="px-3">หนังสือมอบอำนาจ</span>
                                                <Button
                                                    href={data?.fAuthorisePath}
                                                    className="download-btn me-3 rounded-pill"
                                                    download
                                                >
                                                    <BsDownload className="me-2" />
                                                    ดาวน์โหลด
                                                </Button>
                                            </FormGroup>
                                        ) : null}
                                        {data?.fBureauPath != null ? (
                                            <FormGroup className='d-flex justify-content-between flex-wrap align-items-center'>
                                                <span className="px-3">รายงานข้อมูลเครดิตบูโรของนิติบุคคลที่กู้ยืม (ไม่เกิน 30วัน ในวันที่ยื่นคำขอกู้)</span>
                                                {/* <span className="px-3">เอกสารเครดิตบูโร</span> */}
                                                <Button
                                                    href={data?.fBureauPath}
                                                    className="download-btn mx-3 rounded-pill"
                                                    download
                                                >
                                                    <BsDownload className="me-2" />
                                                    ดาวน์โหลด
                                                </Button>
                                            </FormGroup>
                                        ) : null}
                                        {data?.fStatementPath != null ? (
                                            <FormGroup className='d-flex justify-content-between flex-wrap align-items-center'>
                                                <span className="px-3"> รายงานงบแสดงฐานะการเงิน ซึ่งผ่านการตรวจสอบจากผู้สอบบัญชีเรียบร้อยแล้ว ย้อนหลัง 2ปี</span>
                                                <Button
                                                    href={data?.fStatementPath}
                                                    className="download-btn mx-3 rounded-pill"
                                                    download
                                                >
                                                    <BsDownload className="me-2" />
                                                    ดาวน์โหลด
                                                </Button>
                                            </FormGroup>
                                        ) : null}
                                        {data?.fLocationPath != null ? (
                                            <FormGroup className='d-flex justify-content-between flex-wrap align-items-center'>
                                                <span className="px-3">แผนที่ตั้งสถานที่ประกอบกิจการ / ผู้ดำเนินการทดสอบฝีมือแรงงาน</span>
                                                <Button
                                                    href={data?.fLocationPath}
                                                    className="download-btn mx-3 rounded-pill"
                                                    download
                                                >
                                                    <BsDownload className="me-2" />
                                                    ดาวน์โหลด
                                                </Button>
                                            </FormGroup>
                                        ) : null}
                                        {data?.fSubsidyPath != null ? (
                                            <FormGroup className='d-flex justify-content-between flex-wrap align-items-center'>
                                                <span className="px-3">รายการแสดงการส่งเงินสมทบ(สปส. 1-10 ส่วนที่ 1 ณ เดือนสุดท้ายก่อนยื่นคำขอกู้ หรือ เดือนที่ยื่นคำขอกู้)</span>
                                                <Button
                                                    href={data?.fSubsidyPath}
                                                    className="download-btn mx-3 rounded-pill"
                                                    download
                                                >
                                                    <BsDownload className="me-2" />
                                                    ดาวน์โหลด
                                                </Button>
                                            </FormGroup>
                                        ) : null}
                                        {data?.fOtherPath != null ? (
                                            <FormGroup className='d-flex justify-content-between flex-wrap align-items-center'>
                                                <span className="px-3">เอกสารอื่นๆ </span>
                                                <Button
                                                    href={data?.fOtherPath}
                                                    className="download-btn mx-3 rounded-pill"
                                                    download
                                                >
                                                    <BsDownload className="me-2" />
                                                    ดาวน์โหลด
                                                </Button>
                                            </FormGroup>
                                        ) : null}

                                    </div>
                                </div>


                                <div className="d-flex align-items-center justify-content-center w-100 mt-3">
                                    <button
                                        // onClick={() => { navigate(`/borrowing/admin/Check?req=${searchParams.get("id")}`)}} 
                                        onClick={() => { navigate(-1) }}
                                        className="btn-blue p-2 w-25"
                                    >
                                        ย้อนกลับ
                                    </button>
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    {/* รายละเอียดการขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน */}
                    <TabPanel>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            <div className="form-border p-5">
                                <Tabs>
                                    <TabList>
                                        <Tab>ข้อมูลการขอกู้ยืมเงินเพื่อดำเนินการฝึกอบรม</Tab>
                                        <Tab>ข้อมูลการขอกู้ยืมเงินเพื่อดำเนินการทดสอบมาตรฐานฝีมือแรงงาน</Tab>
                                    </TabList>
                                    {/* ฝึกอบรม */}
                                    <TabPanel>
                                        <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
                                            <TabList>

                                                {trainData.length ? (
                                                    <>
                                                        <h6 className="text-left mt-5">รายชื่อหลักสูตรการฝึกอบรม</h6>
                                                        {/* <h5 className="mt-3 w-100 py-2 text-center" style={{ backgroundColor: "#fdd385" }}>รายชื่อหลักสูตรการฝึกอบรม</h5> */}
                                                        {trainData[0]?.detailCourse?.map((course, i) => (
                                                            <Tab>หลักสูตร {course.courseName}</Tab>
                                                        ))}
                                                    </>
                                                ) : (
                                                    <>
                                                        <h6 className="text-center mt-4">ไม่มีข้อมูลการขอกู้ยืมเงินเพื่อดำเนินการฝึกอบรม</h6>
                                                    </>
                                                )}

                                            </TabList>

                                            {trainData[0]?.detailCourse?.map((course, i) => (
                                                <TabPanel>
                                                    <>
                                                        <Tabs selectedIndex={tabSubIndex} onSelect={(index) => setTabSubIndex(index)}>


                                                            <FormGroup className="mt-5">
                                                                <Label>
                                                                    รายละเอียดประกอบการขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานเพื่อดำเนินการฝึกอบรม
                                                                </Label>
                                                                <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                    {course.inOutTypeName ? course.inOutTypeName : "-"}
                                                                </p>
                                                            </FormGroup>
                                                            <FormGroup>
                                                                <Label>ประเภทการฝึกอบรม</Label>
                                                                <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                    {course.trainingTypeName ? course.trainingTypeName : "-"}
                                                                </p>
                                                            </FormGroup>
                                                            <FormGroup>
                                                                <Label>ชื่อหลักสูตร</Label>
                                                                <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                    {course.courseName ? course.courseName : "-"}
                                                                </p>
                                                            </FormGroup>
                                                            <FormGroup className="d-flex justify-content-start align-items-center">
                                                                <Label>ระยะเวลาในการฝึกอบรมจำนวน</Label>
                                                                <p className="customer-type border border-1 py-1 px-3 mx-2 w-25 rounded-pill text-center">
                                                                    {course.periodTrainCourse ? course.periodTrainCourse : "-"}
                                                                </p>
                                                                <Label>ชั่วโมง/หลักสูตร</Label>
                                                            </FormGroup>

                                                            <FormGroup>
                                                                <Label>หัวข้อและเนื้อหาวิชา</Label>
                                                                {course.detailSubject.map((subject, o) => (
                                                                    <React.Fragment key={o}>
                                                                        <br />
                                                                        <div className="mx-4">
                                                                            <Label>หัวข้อวิชา</Label>
                                                                            <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-left">
                                                                                {subject?.subjectName ?? "-"}
                                                                            </p>
                                                                            <Label>ระยะเวลา (ชั่วโมง)</Label>
                                                                            <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-left">
                                                                                {subject?.duration ?? "-"}
                                                                            </p>
                                                                            <Label>เนื้อหาวิชา</Label>
                                                                            <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-left">
                                                                                {subject?.subjectDetail ?? "-"}
                                                                            </p>
                                                                        </div>

                                                                    </React.Fragment>
                                                                ))}
                                                            </FormGroup>
                                                            <TabList>
                                                                <h5 className="mt-4">รุ่นการฝึกอบรม</h5>
                                                                {course?.trainClass?.map((classItem, i) => (
                                                                    <Tab>รุ่นที่ {i + 1}</Tab>
                                                                ))}

                                                            </TabList>
                                                            {course?.trainClass?.map((classItem, i) => (
                                                                <TabPanel>
                                                                    <FormGroup row>
                                                                        <Label sm={4}>
                                                                            จำนวนลูกจ้างที่เข้ารับการฝึกอบรม
                                                                        </Label>
                                                                        <Col sm={3}>
                                                                            <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                {NumberWithCommmas2(classItem.employeeAmount) ? NumberWithCommmas2(classItem.employeeAmount) : "-"}
                                                                            </p>
                                                                        </Col>
                                                                        <Label sm={4}>คน</Label>
                                                                    </FormGroup>

                                                                    <FormGroup row>
                                                                        <Label sm={4}>
                                                                            ค่าใช้จ่ายในการฝึกอบรม
                                                                        </Label>
                                                                        <Col sm={3}>
                                                                            <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                {NumberWithCommmas2(classItem.payment) ? NumberWithCommmas2(classItem.payment) : "-"}
                                                                            </p>
                                                                        </Col>
                                                                        <Label sm={4}>บาท</Label>
                                                                    </FormGroup>

                                                                    <Label for="" className="mt-2 my-4">
                                                                        ระยะเวลาการฝึกอบรม
                                                                    </Label>

                                                                    <Table className="styled-table mt-3 w-100" bordered hover>
                                                                        <thead>
                                                                            <tr className="text-white text-center" style={{ lineHeight: "3rem", backgroundColor: "#0A66C2" }}>
                                                                                <th style={{ width: 80 }}>ลำดับ</th>
                                                                                <th>วันที่เริ่มฝึกอบรม</th>
                                                                                <th>วันที่สิ้นสุดการฝึกอบรม</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {classItem?.trainClassSessions?.length === 0 ? (
                                                                                <tr>
                                                                                    <td colSpan={4} className="text-center text-muted">
                                                                                        ยังไม่มีรอบการฝึกอบรม
                                                                                    </td>
                                                                                </tr>
                                                                            ) : (
                                                                                classItem?.trainClassSessions?.map((session, i) => {

                                                                                    return (
                                                                                        <tr key={i}>
                                                                                            <td className="text-center align-middle">{i + 1}</td>

                                                                                            <td>
                                                                                                {session.sessionStartDateSt}
                                                                                            </td>

                                                                                            <td>
                                                                                                {session.sessionEndDateSt}
                                                                                            </td>

                                                                                        </tr>
                                                                                    );
                                                                                })
                                                                            )}
                                                                        </tbody>
                                                                    </Table>
                                                                    {/* <FormGroup row>
                                                                        <Label for="" className="mt-2 my-4">
                                                                            ระยะเวลาการฝึกอบรม
                                                                        </Label>
                                                                        <Label for="" sm={1}>
                                                                            วันที่
                                                                        </Label>
                                                                        <Col sm={5}>
                                                                            <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                {classItem.startDateStr ? classItem.startDateStr : "-"}
                                                                            </p>
                                                                        </Col>
                                                                        <Label for="" sm={1}>
                                                                            ถึง
                                                                        </Label>
                                                                        <Col sm={5}>
                                                                            <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                {classItem.endDateStr ? classItem.endDateStr : "-"}
                                                                            </p>
                                                                        </Col>
                                                                    </FormGroup> */}

                                                                    <FormGroup row>
                                                                        <Label>สถานที่ฝึกอบรม</Label>
                                                                        <div className="px-4 pt-4">
                                                                            <FormGroup className="">
                                                                                <Label>ชื่อสถานที่ฝึกอบรม</Label>
                                                                                <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                    {classItem.locationName ? classItem.locationName : "-"}
                                                                                </p>
                                                                            </FormGroup>

                                                                            <FormGroup row>
                                                                                <Label for="addNo" sm={2}>
                                                                                    เลขที่
                                                                                </Label>
                                                                                <Col sm={4}>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {classItem.addressNo ? classItem.addressNo : "-"}
                                                                                    </p>
                                                                                </Col>

                                                                                <Label for="moo" sm={2}>
                                                                                    หมู่ที่
                                                                                </Label>
                                                                                <Col sm={4}>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {classItem.moo ? classItem.moo : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </FormGroup>

                                                                            <FormGroup row>
                                                                                <Label for="soi" sm={2}>
                                                                                    ซอย
                                                                                </Label>
                                                                                <Col sm={4}>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {classItem.soi ? classItem.soi : "-"}
                                                                                    </p>
                                                                                </Col>

                                                                                <Label for="street" sm={2}>
                                                                                    ถนน
                                                                                </Label>
                                                                                <Col sm={4}>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {classItem.soi ? classItem.soi : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </FormGroup>

                                                                            <FormGroup row>
                                                                                <Label sm={2}>จังหวัด</Label>
                                                                                <Col sm={4}>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {classItem.provinceName ? classItem.provinceName : "-"}
                                                                                    </p>
                                                                                </Col>

                                                                                <Label sm={2}>อำเภอ/เขต</Label>
                                                                                <Col sm={4}>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {classItem.amphurName ? classItem.amphurName : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </FormGroup>

                                                                            <FormGroup row>
                                                                                <Label sm={2}>ตำบล/แขวง</Label>
                                                                                <Col sm={4}>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {classItem.tumbonName ? classItem.tumbonName : "-"}
                                                                                    </p>
                                                                                </Col>

                                                                                <Label sm={2}>รหัสไปรษณีย์</Label>
                                                                                <Col sm={4}>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {classItem.postCode ? classItem.postCode : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </FormGroup>
                                                                            <FormGroup row>
                                                                                <Label sm={2}>โทรศัพท์</Label>
                                                                                <Col sm={4}>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {classItem.phone ? classItem.phone : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                                <Label sm={2}>โทรศัพท์มือถือ</Label>
                                                                                <Col sm={4}>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {classItem.mobile ? classItem.mobile : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </FormGroup>
                                                                            <FormGroup row>
                                                                                <Label sm={2}>โทรสาร</Label>
                                                                                <Col sm={4}>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {classItem.fax ? classItem.fax : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                                <Label sm={2}>อีเมล</Label>
                                                                                <Col sm={4}>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {classItem.email ? classItem.email : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </FormGroup>
                                                                        </div>
                                                                    </FormGroup>

                                                                    <FormGroup className="">
                                                                        <Label for="dept">ค่าตอบแทนวิทยากร</Label>
                                                                        <Row className="pt-3">
                                                                            <Col>
                                                                                <Label for="">
                                                                                    อัตราชั่วโมงละ (บาท)
                                                                                </Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {NumberWithCommmas2(classItem.tutorRate) ? NumberWithCommmas2(classItem.tutorRate) : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>

                                                                            <Col>
                                                                                <Label for="">
                                                                                    ระยะเวลา (ชั่วโมง)
                                                                                </Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {classItem.tutorDuration ? classItem.tutorDuration : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>

                                                                            <Col>
                                                                                <Label for="">
                                                                                    จำนวนวิทยากร (คน)
                                                                                </Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {classItem.tutorTotal ? classItem.tutorTotal : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>
                                                                        </Row>
                                                                    </FormGroup>
                                                                    <FormGroup row className="mt-3">
                                                                        <Label
                                                                            for=""
                                                                            sm={3}
                                                                            className="text-center"
                                                                        >
                                                                            จำนวนเงิน (บาท)
                                                                        </Label>
                                                                        <Col sm={9}>
                                                                            <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                {NumberWithCommmas2(((classItem.tutorRate) * (classItem.tutorDuration)) * (classItem.tutorTotal)) ? NumberWithCommmas2(((classItem.tutorRate) * (classItem.tutorDuration)) * (classItem.tutorTotal)) : "-"}
                                                                            </p>
                                                                        </Col>
                                                                    </FormGroup>
                                                                    <Label className="mt-3" for="">
                                                                        ค่าวัสดุต่างๆ
                                                                        ที่ใช้ในการฝึกอบรมฝีมือแรงงาน
                                                                        จะต้องมีลักษณะการใช้สอดคล้องกับเนื้อหาวิชาในหลักสูตรนั้นๆ
                                                                        ทั้งนี้
                                                                        วัสดุดังกล่าวจะต้องไม่ปะปนกับที่ใช้ในการประกอบกิจการตามปกติ
                                                                        (ยกเว้นวัสดุคงสภาพและคอมพิวเตอร์)
                                                                    </Label>

                                                                    <div className="mx-2 pt-3">
                                                                        <Row className="pt-3">
                                                                            <Col>
                                                                                <Label for="">จำนวนเงิน (บาท)</Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {NumberWithCommmas2(classItem.matterialRate) ? NumberWithCommmas2(classItem.matterialRate) : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>

                                                                            <Col>
                                                                                <Label for="">
                                                                                    จำนวนผู้รับการฝึก (คน)
                                                                                </Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {classItem.matterialTotal ? classItem.matterialTotal : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>

                                                                            <Col>
                                                                                <Label for="">
                                                                                    เฉลี่ยต่อคนเป็นจำนวนเงิน (บาท)
                                                                                </Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {NumberWithCommmas2(Number(classItem.matterialRate) / Number(classItem.matterialTotal)) ? NumberWithCommmas2(Number(classItem.matterialRate) / Number(classItem.matterialTotal)) : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                    <Label className="mt-4" for="">
                                                                        ค่าเช่าสถานที่จัดฝึกอบรม
                                                                    </Label>

                                                                    <div className="mx-2 pt-3">
                                                                        <Row className="pt-3">
                                                                            <Col>
                                                                                <Label for="">จำนวนเงิน (บาท)</Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {NumberWithCommmas2(classItem.locationRate) ? NumberWithCommmas2(classItem.locationRate) : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>

                                                                            <Col>
                                                                                <Label for="">
                                                                                    จำนวนผู้รับการฝึก (คน)
                                                                                </Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {classItem.employeeTotal ? classItem.employeeTotal : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                    <Label className="mt-4" for="bake">
                                                                        ค่าเช่าที่พัก ค่าอาหาร
                                                                        ค่าเครื่องดื่มและอาหารว่างสำหรับผู้รับการฝึกอบรม
                                                                        เจ้าหน้าที่ประสานการฝึกอบรม
                                                                        และวิทยากรระหว่างฝึกอบรม
                                                                        ยกเว้นเครื่องดื่มที่มีแอลกอฮอล
                                                                    </Label>
                                                                    <div className="mx-2 pt-3">
                                                                        <FormGroup row className="mt-3">
                                                                            <Label
                                                                                for=""
                                                                                sm={3}
                                                                                className="text-center"
                                                                            >
                                                                                จำนวนเงิน (บาท)
                                                                            </Label>
                                                                            <Col sm={9}>
                                                                                <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                    {NumberWithCommmas2(classItem.bakeRate) ? NumberWithCommmas2(classItem.bakeRate) : "-"}
                                                                                </p>
                                                                            </Col>
                                                                        </FormGroup>
                                                                        <Row className="pt-3">
                                                                            <Col>
                                                                                <Label for="">
                                                                                    จำนวนผู้รับการฝึก (คน)
                                                                                </Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {NumberWithCommmas2(classItem.bakeTotal) ? NumberWithCommmas2(classItem.bakeTotal) : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>

                                                                            <Col>
                                                                                <Label for="">
                                                                                    เฉลี่ยต่อคนเป็นจำนวนเงิน (บาท)
                                                                                </Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {NumberWithCommmas2((Number(classItem.bakeRate) / (Number(classItem.bakeTotal) + Number(classItem.bakeTutorTotal)))) ?
                                                                                            NumberWithCommmas2((Number(classItem.bakeRate) / (Number(classItem.bakeTotal) + Number(classItem.bakeTutorTotal)))) : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row className="pt-3">
                                                                            <Col>
                                                                                <Label for="">
                                                                                    เจ้าหน้าที่/วิทยากร (คน)
                                                                                </Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {NumberWithCommmas2(classItem.bakeTutorTotal) ? NumberWithCommmas2(classItem.bakeTutorTotal) : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>

                                                                            <Col>
                                                                                <Label for="">
                                                                                    เฉลี่ยต่อคนเป็นจำนวนเงิน (บาท)
                                                                                </Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {NumberWithCommmas2((Number(classItem.bakeRate) / (Number(classItem.bakeTotal) + Number(classItem.bakeTutorTotal)))) ?
                                                                                            NumberWithCommmas2((Number(classItem.bakeRate) / (Number(classItem.bakeTotal) + Number(classItem.bakeTutorTotal)))) : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                    <Label className="mt-4" for="">
                                                                        ค่าใช้จ่ายอื่นๆ (ถ้ามี)
                                                                    </Label>
                                                                    <Col>
                                                                        <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                            {classItem.otherName ? classItem.otherName : "-"}

                                                                        </p>
                                                                    </Col>
                                                                    <div className="mx-2 pt-3">
                                                                        <Row className="pt-3">
                                                                            <Col>
                                                                                <Label for="">
                                                                                    จำนวนเงิน (บาท)
                                                                                </Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">

                                                                                        {classItem.otherRate ? NumberWithCommmas2(classItem.otherRate) : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>

                                                                            <Col>
                                                                                <Label for="">
                                                                                    จำนวนผู้รับการฝึก (คน)
                                                                                </Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {classItem.otherTotal ? NumberWithCommmas2(classItem.otherTotal) : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>

                                                                            <Col>
                                                                                <Label for="">
                                                                                    เฉลี่ยต่อคนเป็นจำนวนเงิน (บาท)
                                                                                </Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {classItem.otherRate && classItem.otherTotal ? NumberWithCommmas2(classItem.otherRate / classItem.otherTotal) : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>

                                                                    <Label className="mt-3" for="">
                                                                        รวมค่าใช้จ่ายทั้งหมด
                                                                    </Label>

                                                                    <div className="mx-2 mb-4">
                                                                        <Row className="pt-3">
                                                                            <Col>
                                                                                <Label for="">จำนวนเงิน (บาท)</Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {NumberWithCommmas2(((classItem.tutorRate) * (classItem.tutorDuration)) * (classItem.tutorTotal) + (Number(classItem.matterialRate) + Number(classItem.locationRate) + Number(classItem.bakeRate) + Number(classItem.otherRate)))
                                                                                            ?
                                                                                            NumberWithCommmas2(((classItem.tutorRate) * (classItem.tutorDuration)) * (classItem.tutorTotal) + (Number(classItem.matterialRate) + Number(classItem.locationRate) + Number(classItem.bakeRate) + Number(classItem.otherRate)))
                                                                                            : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>

                                                                            <Col>
                                                                                <Label for="">
                                                                                    เฉลี่ยต่อคนเป็นจำนวนเงิน (บาท)
                                                                                </Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {NumberWithCommmas2((((classItem.tutorRate) * (classItem.tutorDuration)) * (classItem.tutorTotal) + (Number(classItem.matterialRate) + Number(classItem.locationRate) + Number(classItem.bakeRate) + Number(classItem.otherRate)))
                                                                                            / (Number(classItem.bakeTotal) + Number(classItem.bakeTutorTotal))
                                                                                        )
                                                                                            ?
                                                                                            NumberWithCommmas2((((classItem.tutorRate) * (classItem.tutorDuration)) * (classItem.tutorTotal) + (Number(classItem.matterialRate) + Number(classItem.locationRate) + Number(classItem.bakeRate) + Number(classItem.otherRate)))
                                                                                                / (Number(classItem.bakeTotal) + Number(classItem.bakeTutorTotal))
                                                                                            )
                                                                                            : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                </TabPanel>
                                                            ))}

                                                        </Tabs>
                                                    </>
                                                </TabPanel>
                                            ))}

                                        </Tabs>
                                    </TabPanel>
                                    {/* ทดสอบ */}
                                    <TabPanel>
                                        <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
                                            <TabList>

                                                {testData.length ? (
                                                    <>
                                                        <h5 className="mt-3">รายชื่อสาขาอาชีพ</h5>
                                                        {testData[0]?.detailTest?.map((test, i) => (
                                                            <Tab>สาขาอาชีพ {test.lawOcupationName}</Tab>
                                                        ))}
                                                    </>
                                                ) : (
                                                    <>
                                                        <h6 className="text-center mt-4">ไม่มีข้อมูลการขอดำเนินการทดสอบมาตรฐานฝีมือแรงงาน</h6>
                                                    </>
                                                )}

                                            </TabList>

                                            {testData[0]?.detailTest?.map((test, i) => (
                                                <TabPanel>
                                                    <>
                                                        <Tabs selectedIndex={tabSubIndex} onSelect={(index) => setTabSubIndex(index)}>

                                                            <FormGroup>
                                                                <Label>สาขาอาชีพ</Label>
                                                                <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                    {test.lawOcupationName ? test.lawOcupationName : "-"}
                                                                </p>
                                                            </FormGroup>
                                                            {test.detailLawOcu.map((lawTest, s) => (
                                                                <FormGroup key={s} className="d-flex px-5">
                                                                    <div className="w-50 mx-1">
                                                                        <Label>สาขา</Label>
                                                                        <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                            {lawTest.testOcupationIdLevelName ? lawTest.testOcupationIdLevelName : "-"}
                                                                        </p>
                                                                    </div>
                                                                    <div className="w-50 mx-1">
                                                                        <Label>ระดับ</Label>
                                                                        <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                            {lawTest.testOcupationIdLevel ? lawTest.testOcupationIdLevel : "-"}
                                                                        </p>
                                                                    </div>
                                                                </FormGroup>
                                                            ))}

                                                            <TabList>
                                                                <h5 className="mt-4">จำนวนครั้งที่ดำเนินการทดสอบฯ</h5>
                                                                {test?.testTime?.map((time, k) => (
                                                                    <Tab>ครั้งที่{+1}</Tab>
                                                                ))}

                                                            </TabList>

                                                            {test?.testTime?.map((time) => (
                                                                <TabPanel key={time.time}>
                                                                    <Label>
                                                                        รายละเอียดการทดสอบมาตรฐานฝีมือแรงงาน
                                                                    </Label>

                                                                    <Label className="mb-4">
                                                                        ค่าใช้จ่ายในการทดสอบมาตรฐานฝีมือแรงงาน
                                                                        จำนวน
                                                                        <span className="customer-type border border-1 py-1 px-3 mx-3 rounded-pill w-100 text-center">
                                                                            {NumberWithCommmas2(time.paymentAmount) ? NumberWithCommmas2(time.paymentAmount) : "-"}
                                                                        </span>
                                                                        บาท
                                                                    </Label>
                                                                    <FormGroup row>
                                                                        <Label for="" className="mt-2 my-4">
                                                                            ระยะเวลาการทดสอบมาตรฐานฝีมือแรงงาน
                                                                        </Label>
                                                                        <Label for="" sm={1}>
                                                                            วันที่
                                                                        </Label>
                                                                        <Col sm={5}>
                                                                            <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                {time.startDateStr ? time.startDateStr : "-"}
                                                                            </p>
                                                                        </Col>
                                                                        <Label for="" sm={1}>
                                                                            ถึง
                                                                        </Label>
                                                                        <Col sm={5}>
                                                                            <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                {time.endDateStr ? time.endDateStr : "-"}
                                                                            </p>
                                                                        </Col>
                                                                    </FormGroup>

                                                                    <Label className="mb-4">
                                                                        จำนวนผู้เข้ารับการทดสอบ
                                                                        <span className="customer-type border border-1 py-1 px-3 mx-3 rounded-pill w-100 text-center">
                                                                            {NumberWithCommmas2(time.personTotal) ? NumberWithCommmas2(time.personTotal) : "-"}
                                                                        </span>
                                                                        คน
                                                                    </Label>

                                                                    <FormGroup row>
                                                                        <Label>สถานที่ดำเนินการทดสอบ</Label>
                                                                        <div className="px-4 pt-4">
                                                                            <FormGroup className="mb-4">
                                                                                <Label>
                                                                                    ชื่อสถานที่ดำเนินการทดสอบ
                                                                                </Label>
                                                                                <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                    {time.locationName ? time.locationName : "-"}
                                                                                </p>
                                                                            </FormGroup>

                                                                            <FormGroup row>
                                                                                <Label for="addNo" sm={2}>
                                                                                    เลขที่
                                                                                </Label>
                                                                                <Col sm={4}>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {time.addressNo ? time.addressNo : "-"}
                                                                                    </p>
                                                                                </Col>

                                                                                <Label for="moo" sm={2}>
                                                                                    หมู่ที่
                                                                                </Label>
                                                                                <Col sm={4}>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {time.moo ? time.moo : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </FormGroup>

                                                                            <FormGroup row>
                                                                                <Label for="soi" sm={2}>
                                                                                    ซอย
                                                                                </Label>
                                                                                <Col sm={4}>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {time.soi ? time.soi : "-"}
                                                                                    </p>
                                                                                </Col>

                                                                                <Label for="street" sm={2}>
                                                                                    ถนน
                                                                                </Label>
                                                                                <Col sm={4}>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {time.soi ? time.soi : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </FormGroup>

                                                                            <FormGroup row>
                                                                                <Label sm={2}>จังหวัด</Label>
                                                                                <Col sm={4}>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {time.provinceCode ? time.provinceCode : "-"}
                                                                                    </p>
                                                                                </Col>

                                                                                <Label sm={2}>อำเภอ/เขต</Label>
                                                                                <Col sm={4}>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {time.amphurCode ? time.amphurCode : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </FormGroup>

                                                                            <FormGroup row>
                                                                                <Label sm={2}>ตำบล/แขวง</Label>
                                                                                <Col sm={4}>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {time.tumbonCode ? time.tumbonCode : "-"}
                                                                                    </p>
                                                                                </Col>

                                                                                <Label sm={2}>รหัสไปรษณีย์</Label>
                                                                                <Col sm={4}>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {time.postCode ? time.postCode : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                                <FormGroup row>
                                                                                    <Label sm={2}>โทรศัพท์</Label>
                                                                                    <Col sm={4}>
                                                                                        <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                            {time.phone ? time.phone : "-"}
                                                                                        </p>
                                                                                    </Col>
                                                                                    <Label sm={2}>โทรศัพท์มือถือ</Label>
                                                                                    <Col sm={4}>
                                                                                        <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                            {time.mobile ? time.mobile : "-"}
                                                                                        </p>
                                                                                    </Col>
                                                                                </FormGroup>
                                                                                <FormGroup row>
                                                                                    <Label sm={2}>โทรสาร</Label>
                                                                                    <Col sm={4}>
                                                                                        <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                            {time.fax ? time.fax : "-"}
                                                                                        </p>
                                                                                    </Col>
                                                                                    <Label sm={2}>อีเมล</Label>
                                                                                    <Col sm={4}>
                                                                                        <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                            {time.email ? time.email : "-"}
                                                                                        </p>
                                                                                    </Col>
                                                                                </FormGroup>
                                                                            </FormGroup>
                                                                        </div>
                                                                    </FormGroup>
                                                                    <Label>
                                                                        ข้อมูลประมาณการรายการค่าใช้จ่ายรายครั้ง
                                                                    </Label>

                                                                    <Label className="mb-4">
                                                                        ค่าใช้จ่ายในการทดสอบมาตรฐานฝีมือแรงงาน จำนวน
                                                                        <span className="customer-type border border-1 py-1 px-3 mx-3 rounded-pill w-100 text-center">
                                                                            {NumberWithCommmas2(time.paymentAmount) ? NumberWithCommmas2(time.paymentAmount) : "-"}
                                                                        </span>
                                                                        บาท
                                                                    </Label>
                                                                    <br />
                                                                    <Label className="mb-4">
                                                                        จำนวนผู้เข้ารับการทดสอบ
                                                                        <span className="customer-type border border-1 py-1 px-3 mx-3 rounded-pill w-100 text-center">
                                                                            {NumberWithCommmas2(time.personTotal) ? NumberWithCommmas2(time.personTotal) : "-"}
                                                                        </span>
                                                                        คน
                                                                    </Label>
                                                                    <Label for="">
                                                                        รายละเอียดประกอบการขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานเพื่อดำเนินการทดสอบมาตรฐานฝีมือแรงงาน
                                                                    </Label>
                                                                    <div className="px-3 mt-3">
                                                                        <FormGroup className="d-flex align-items-center justify-content-between">
                                                                            <Label className="w-50">
                                                                                ลูกจ้างของตนเอง จำนวนผู้เข้ารับการทดสอบ
                                                                            </Label>
                                                                            <p className="customer-type border border-1 py-1 px-3 mx-3 rounded-pill w-50 text-center">
                                                                                {NumberWithCommmas2(time.employTestTotal) ? NumberWithCommmas2(time.employTestTotal) : "-"}
                                                                            </p>
                                                                            <Label className="">คน</Label>
                                                                        </FormGroup>

                                                                        <FormGroup className="d-flex align-items-center justify-content-between">
                                                                            <Label className="w-50">
                                                                                บุคคลภายนอก จำนวนผู้เข้ารับการทดสอบ
                                                                            </Label>
                                                                            <p className="customer-type border border-1 py-1 px-3 mx-3 rounded-pill w-50 text-center">
                                                                                {NumberWithCommmas2(time.unEmployTestTotal) ? NumberWithCommmas2(time.unEmployTestTotal) : "-"}
                                                                            </p>
                                                                            <Label className="">คน</Label>
                                                                        </FormGroup>
                                                                    </div>
                                                                    <FormGroup className="pt-3">
                                                                        <Label for="dept">
                                                                            ค่าทดสอบเรียกเก็บ
                                                                            <span className="require-input">*</span>
                                                                        </Label>
                                                                        <Row className="pt-3">
                                                                            <Col>
                                                                                <Label for="">จำนวนเงิน (บาท)</Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {NumberWithCommmas2(time.testPaymentAmount) ? NumberWithCommmas2(time.testPaymentAmount) : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>

                                                                            <Col>
                                                                                <Label for="">
                                                                                    จำนวนผู้เข้ารับการทดสอบ (คน)
                                                                                </Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">

                                                                                        {NumberWithCommmas2(time.testPersonAmount) ? NumberWithCommmas2(time.testPersonAmount) : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>

                                                                            <Col>
                                                                                <Label for="">
                                                                                    เฉลี่ยต่อคนเป็นจำนวนเงิน
                                                                                </Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {NumberWithCommmas2(time.testPaymentAmount / time.testPersonAmount) ? NumberWithCommmas2(time.testPaymentAmount / time.testPersonAmount) : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>
                                                                        </Row>
                                                                    </FormGroup>
                                                                    <Label className="" for="">
                                                                        ค่าตอบแทนผู้ทดสอบ
                                                                    </Label>

                                                                    <div className="mx-2">
                                                                        <Row className="pt-3">
                                                                            <Col>
                                                                                <Label for="">จำนวนเงิน (บาท)</Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {NumberWithCommmas2(time.testerPaymentAmount) ? NumberWithCommmas2(time.testerPaymentAmount) : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>

                                                                            <Col>
                                                                                <Label for="">
                                                                                    จำนวนผู้ทดสอบ (คน)
                                                                                </Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {NumberWithCommmas2(time.testerAmount) ? NumberWithCommmas2(time.testerAmount) : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>

                                                                            <Col>
                                                                                <Label for="">
                                                                                    เฉลี่ยต่อคนเป็นจำนวนเงิน
                                                                                </Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {NumberWithCommmas2(time.testerPaymentAmount / time.testerAmount) ? NumberWithCommmas2(time.testerPaymentAmount / time.testerAmount) : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                    <Label className="mt-3" for="">
                                                                        ค่าวัสดุ
                                                                    </Label>

                                                                    <div className="mx-2">
                                                                        <Row className="pt-3">
                                                                            <Col>
                                                                                <Label for="">จำนวนเงิน (บาท)</Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {NumberWithCommmas2(time.materialPaymentAmount) ? NumberWithCommmas2(time.materialPaymentAmount) : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>

                                                                            <Col>
                                                                                <Label for="">
                                                                                    จำนวนผู้เข้ารับการทดสอบ (คน)
                                                                                </Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {NumberWithCommmas2(time.materialAmount) ? NumberWithCommmas2(time.materialAmount) : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>

                                                                            <Col>
                                                                                <Label for="">
                                                                                    เฉลี่ยต่อคนเป็นจำนวนเงิน
                                                                                </Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {NumberWithCommmas2(time.materialAmount / time.materialAmount) ? NumberWithCommmas2(time.materialAmount / time.materialAmount) : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                    {time.otherName != null ? (
                                                                        <>
                                                                            <Label className="mt-4" for="">
                                                                                ค่าใช้จ่ายอื่นๆ (ถ้ามี)
                                                                            </Label>
                                                                            <Col>
                                                                                <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                    {time.otherName ? time.otherName : "-"}
                                                                                </p>
                                                                            </Col>
                                                                            <div className="mx-2 pt-3">
                                                                                <Row className="pt-3">
                                                                                    <Col>
                                                                                        <Label for="">
                                                                                            จำนวนเงิน (บาท)
                                                                                        </Label>
                                                                                        <Col>
                                                                                            <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                                {NumberWithCommmas2(time.otherPaymentAmount) ? NumberWithCommmas2(time.otherPaymentAmount) : "-"}
                                                                                            </p>
                                                                                        </Col>
                                                                                    </Col>

                                                                                    <Col>
                                                                                        <Label for="">
                                                                                            จำนวนผู้รับการฝึก (คน)
                                                                                        </Label>
                                                                                        <Col>
                                                                                            <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                                {NumberWithCommmas2(time.otherPersonAmount) ? NumberWithCommmas2(time.otherPersonAmount) : "-"}
                                                                                            </p>
                                                                                        </Col>
                                                                                    </Col>

                                                                                    <Col>
                                                                                        <Label for="">
                                                                                            เฉลี่ยต่อคนเป็นจำนวนเงิน (บาท)
                                                                                        </Label>
                                                                                        <Col>
                                                                                            <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                                {NumberWithCommmas2(Number(time.otherPaymentAmount) / Number(time.otherPersonAmount)) ? NumberWithCommmas2(Number(time.otherPaymentAmount) / Number(time.otherPersonAmount)) : "-"}
                                                                                            </p>
                                                                                        </Col>
                                                                                    </Col>
                                                                                </Row>
                                                                            </div>
                                                                        </>
                                                                    ) : null}

                                                                    <Label className="mt-3" for="">
                                                                        รวมค่าใช้จ่ายทั้งหมด

                                                                    </Label>

                                                                    <div className="mx-2 mb-4">
                                                                        <Row className="pt-3">
                                                                            <Col>
                                                                                <Label for="">จำนวนเงิน (บาท)</Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {NumberWithCommmas2(Number(time.testPaymentAmount) + Number(time.testerPaymentAmount) + Number(time.materialPaymentAmount) + Number(time.otherPaymentAmount)) ?
                                                                                            NumberWithCommmas2(Number(time.testPaymentAmount) + Number(time.testerPaymentAmount) + Number(time.materialPaymentAmount) + Number(time.otherPaymentAmount)) : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>

                                                                            <Col>
                                                                                <Label for="">
                                                                                    เฉลี่ยต่อคนเป็นจำนวนเงิน (บาท)
                                                                                </Label>
                                                                                <Col>
                                                                                    <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                                                                                        {NumberWithCommmas2((Number(time.testPaymentAmount) + Number(time.testerPaymentAmount) + Number(time.materialPaymentAmount) + Number(time.otherPaymentAmount)) / (Number(time.employTestTotal) + Number(time.unEmployTestTotal))) ?
                                                                                            NumberWithCommmas2((Number(time.testPaymentAmount) + Number(time.testerPaymentAmount) + Number(time.materialPaymentAmount) + Number(time.otherPaymentAmount)) / (Number(time.employTestTotal) + Number(time.unEmployTestTotal))) : "-"}
                                                                                    </p>
                                                                                </Col>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>

                                                                </TabPanel>
                                                            ))}

                                                        </Tabs>
                                                    </>
                                                </TabPanel>
                                            ))}

                                        </Tabs>
                                    </TabPanel>
                                </Tabs>
                                <div className="d-flex align-items-center justify-content-center w-100 mt-3">
                                    <button onClick={() => {
                                        // navigate( `/borrowing/admin/Check?req=${searchParams.get("id")}`);
                                        navigate(-1);
                                    }} className="btn-blue p-2 w-25">ย้อนกลับ</button>
                                </div>
                            </div>


                        </div>
                    </TabPanel>
                    {/* ข้อมูลตำแหน่งงาน */}
                    <TabPanel>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            <div className="form-border p-5">
                                <Tabs>
                                    <TabList>
                                        <Tab>ข้อมูลตำแหน่งงานสำหรับดำเนินการฝึกอบรม</Tab>
                                        <Tab>ข้อมูลตำแหน่งงานสำหรับดำเนินการทดสอบมาตรฐานฝีมือแรงงาน</Tab>
                                    </TabList>
                                    <TabPanel className="mt-5">
                                        <CreateTableComponent column={COLUMNSTRAIN} dataInput={detailJobPositionDataAr} showEntrie={true} showPage={true} />
                                    </TabPanel>
                                    <TabPanel className="mt-5">
                                        <CreateTableComponent column={COLUMNSTEST} dataInput={testJobposition} showEntrie={true} showPage={true} />
                                    </TabPanel>
                                </Tabs>
                                <div className="d-flex align-items-center justify-content-center w-100 mt-3">
                                    <button onClick={() => {
                                        // navigate( `/borrowing/admin/Check?req=${searchParams.get("id")}`);
                                        navigate(-1);
                                    }} className="btn-blue p-2 w-25">ย้อนกลับ</button>
                                </div>
                            </div>
                        </div>

                    </TabPanel>
                </Tabs>
            </Container>

            <Modal
                isOpen={openModalForm}
                toggle={Toggle}
                scrollable
                backdrop={'static'}
                keyboard={false}
                centered
                size="lg"
            >
                <ModalHeader toggle={Toggle} className="text-center styled-modal">
                    รายละเอียดข้อมูลตำแหน่งงาน
                </ModalHeader>
                <ModalBody>

                    <div className="w-100">
                        <div className="p-4">
                            <Label
                                className="me-4 w-100 "
                                style={{ lineHeight: "30px" }}
                            >
                                ชื่อตำแหน่งงาน
                            </Label>
                            <Input
                                type="text"
                                name={`trainJobpositionName`}
                                disabled
                                className="cus-type rounded-pill text-center input-color"
                                {...trainFormik.getFieldProps("trainJobpositionName")}
                            >

                            </Input>


                            <Label
                                className='mt-3'>
                                หลักสูตรและรุ่นการฝึกอบรม
                                <span className="require-input">*</span>
                            </Label>
                            {courseSelect?.map((course, i) => (
                                <div className='mt-3 px-3' key={i}>
                                    <li>หลักสูตร <span style={{ color: "#0A66C2" }}>{course.courseName}</span></li>
                                    {course?.listTrainClasses?.map((classItem, index) => (
                                        <div key={index} >
                                            <div className='d-flex align-items-center mt-3'>
                                                <span className='ms-2'>
                                                    รุ่นที่ <span style={{ color: "#0A66C2" }}>{classItem?.classItem}</span>
                                                </span>

                                                <span className='ms-2'>
                                                    จำนวนผู้เข้ารับการฝึกอบรม
                                                </span>
                                                <span className='ms-3'>
                                                    <span style={{ color: "#0A66C2" }}>{trainFormik.values?.trainCourses[i]?.trainClasses[index]?.personAmount ?? "0"}</span>
                                                </span>
                                                <span className='mx-3'>
                                                    คน
                                                </span>

                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ))}
                            <hr />
                            <div className='d-flex justify-content-center align-items-center'>
                                <button className='btn-blue w-25' onClick={() => Toggle()}>ปิด</button>
                            </div>
                        </div>


                    </div>
                </ModalBody>


            </Modal>
        </>
    );
}



